/** Frontend gate for experimental Solana ecosystem UI. Default false / fail-closed.

Build-time: REACT_APP_SOLANA_ECOSYSTEM_ENABLED — diagnostic only; never enables UI alone.
Runtime: /api/config solana_ecosystem.enabled is the sole enable signal.

Fail-closed rules:
- config null/unavailable → disabled
- config object without solana_ecosystem → disabled
- solana_ecosystem.enabled falsy → disabled
- build-time env must not override any of the above
*/

export function solanaEcosystemEnabledFromEnv() {
  const raw = (process.env.REACT_APP_SOLANA_ECOSYSTEM_ENABLED || "").trim().toLowerCase();
  return raw === "1" || raw === "true" || raw === "yes" || raw === "on";
}

/** @deprecated prefer isSolanaEcosystemEnabled(config) for UI gates */
export const SOLANA_ECOSYSTEM_ENABLED = solanaEcosystemEnabledFromEnv();

/**
 * Experimental Solana UI enable check. Fail closed.
 * @param {object | null | undefined} config Public /api/config payload (or fallback).
 */
export function isSolanaEcosystemEnabled(config) {
  if (config == null || typeof config !== "object") return false;
  return Boolean(config.solana_ecosystem?.enabled);
}
